import { HeatMapCoinGecko } from './HeatMapCoinGecko';

import './HeatMap.css';

export const HeatMap = () => {
  return (
    <div>
        <HeatMapCoinGecko />
    </div>
  )
}
